import { Stack } from '@mui/material';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { BasePageTitle } from '~/components/BasePageTitle/BasePageTitle';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DataGridWidget } from '~/components/DataGridWidget';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';

import { useCommodityGroupDataGridConfig } from './CommodityGroupList.dataGrid';
import { BASE_COMMODITY_GROUP_LIST_QUERY } from './CommodityGroupList.gql';
import { useCommodityGroupDataGridQueryBuilderConfig } from './CommodityGroupList.queryBuilder';

const domain = BaseDomainType.COMMODITY_GROUP;

export const CommodityGroupList = () => {
  const { queryId, query, onQueryChange, onQueryIdChange, rulesTotal, loading } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <PageHeaderStatic
            title={<BasePageTitle domain={domain} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
            right={
              <Stack
                spacing={3}
                direction="row"
                sx={{
                  overflow: 'hidden',
                  alignItems: 'center',
                }}
              >
                <Filters
                  {...filtersProps}
                  selected={selected}
                  onFilterSelect={(filter) => {
                    onQueryIdChange(filter.queryId);
                  }}
                />
              </Stack>
            }
          />
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={useCommodityGroupDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <DataGridWidget
        domain={domain}
        loading={loading}
        filter={query}
        filterCount={rulesTotal}
        useConfig={useCommodityGroupDataGridConfig}
        initialNavigateDetail={() => ({ to: '' })}
        loadingProps={{
          query: BASE_COMMODITY_GROUP_LIST_QUERY,
          getNodes: (data) => data.commodityGroups.nodes,
          getTotalCount: (data) => data.commodityGroups.totalCount || 0,
        }}
      />
    </PageLayout>
  );
};
